module.exports = __webpack_public_path__ + "static/media/Foundation.36238dd6.ttf";